import onBoardImage1 from '@/modules/Auth/assets/images/onBoard1.png';
import onBoardImage2 from '@/modules/Auth/assets/images/onBoard2.png';
import onBoardImage3 from '@/modules/Auth/assets/images/onBoard3.png';

export const onboardingImageSliderData = [
  {
    image: onBoardImage1,
    title: 'تکمیل گزارشات',
    doc: 'تکمیل و بررسی گزارش هر پرونده به صورت جداگانه',
  },

  {
    image: onBoardImage2,
    title: 'انجام بازدید',
    doc: 'انجام بازدید از وسیله‌نقلیهی مشتری و تصویر برداری در زمان معین ',
  },
  {
    image: onBoardImage3,
    title: 'مدیریت پرونده‌ها',
    doc: 'امکان قبول و رد کردن پرونده‌های پیشنهادی و بررسی سایر پرونده‌ها',
  },
];
